<template>
  <div class="single container" :class="{ commonWrap: !confirm }">
    <common-step-bar :current-step="!displayOtpConfirm && !confirm ? 1 : 2" class="marginY4" />
    <div v-if="!displayOtpConfirm && !confirm">
      <payment-status-notification-message v-if="payment_status_notification" :payment-status-notification="payment_status_notification" />
      <div class="margin3">
        <common-flash-message />
        <flash-message v-if="errorMessages && errorMessages.length > 0" :messages="errorMessages" type="error" />
      </div>
      <h2 class="textBold textLarge marginB3">基本情報入力</h2>
      <user-profile-form
        ref="userProfileForm"
        :initial-profile-data="model.profile"
        :age-conditions="ageConditions"
        :gender-condition="ticket.gender"
      />
      <h2 class="textBold textLarge marginB2 marginT5">申込内容</h2>
      <div class="purchaseCard">
        <div class="purchaseCard-event paddingX4 paddingY3">
          <div class="purchaseCard-event-box">
            <img :src="event.eyecatch" :alt="event.event_title" class="purchaseCard-event-box-eyecatch" />
            <div class="purchaseCard-event-box-block">
              <span class="textBold"
                >{{ eventOrganizationTime }}
                <div v-if="eventStartToday" class="purchaseCard-event-box-block-today">本日開催</div></span
              ><br />
              <span class="purchaseCard-event-box-block-area">{{ event.prefecture_name }} / {{ event.area_name }}</span>
            </div>
          </div>
          <div class="purchaseCard-event-title marginT3">{{ event.event_title }}</div>
        </div>
        <div class="purchaseCard-priceData">
          <dl ref="priceDataElement" class="priceData marginX4 marginY3">
            <div class="priceData-item paddingB2">
              <dt class="priceData-item-term">購入枚数</dt>
              <dd v-if="!ticket.original_stage_ticket_id" class="priceData-item-desc">
                <select v-if="canSelectQuantity" v-model="model.purchase.quantity" class="commonInput" @change="onChangeQuantity">
                  <option v-for="(quantity, index) in quantitySelectOptions" :key="index" :value="quantity.value" :disabled="quantity.disabled">
                    {{ quantity.text }}
                  </option>
                </select>
                <template v-else>
                  1枚
                  <p v-if="isMarriageMemberEvent && !isMdgMemberPartyEvent">このイベントは1枚しか購入できません</p>
                </template>
              </dd>
              <dd v-else class="priceData-item-desc">
                <select v-if="canSelectQuantity" v-model="model.purchase.quantity" class="commonInput" @change="onChangeQuantity">
                  <option v-for="(quantity, index) in quantitySelectOptions" :key="index" :value="quantity.value">
                    {{ quantity.text }}
                  </option>
                </select>
                <template v-else>
                  1枚
                  <p v-if="isMarriageMemberEvent && !isMdgMemberPartyEvent">このイベントは1枚しか購入できません</p>
                </template>
              </dd>
              <div v-show="displayTooltip && needDisplayTooltip" class="priceData-item-tooltip">
                <div class="priceData-item-tooltip-inner">{{ tooltipText }}</div>
              </div>
            </div>
            <div v-if="hasGroupDiscount" class="priceData-item paddingY2">
              <div></div>
              <div class="priceData-item-group-discount paddingY2">複数枚購入で割引あり！</div>
            </div>
            <div class="priceData-item paddingY2">
              <dt class="priceData-item-term">{{ ticketName }}</dt>
              <dd class="priceData-item-desc">
                <template v-if="!ticket.original_stage_ticket_id">
                  {{ ticketPrice }}
                </template>
                <template v-else>
                  <span class="price">{{ ticketPrice }}</span>
                  <span class="originPrice">{{ originStageTicketPrice }}</span>
                </template>
              </dd>
            </div>
            <div v-if="isSelectedGroupDiscount" class="priceData-item paddingY2">
              <dt class="priceData-item-term">小計</dt>
              <dd class="priceData-item-desc">{{ numberToCurrency(totalOriginStageTicketPrice) }}</dd>
            </div>
            <div v-if="event.goto_campaign_event" class="priceData-item paddingY2">
              <dt class="priceData-item-term">Go Toイベント割引</dt>
              <dd class="priceData-item-desc">{{ gotoEventTicketDiscount }}</dd>
            </div>
            <div v-if="isSelectedGroupDiscount" class="priceData-item priceData-discountAmount paddingY2">
              <dt class="priceData-item-term">グループ割引</dt>
              <dd class="priceData-item-desc">-{{ numberToCurrency(groupDiscountAmount) }}</dd>
            </div>
            <transition name="fade">
              <div v-if="discountAmount" class="priceData-item paddingY2 priceData-discountAmount">
                <dt class="priceData-item-term">割引</dt>
                <dd class="priceData-item-desc">-{{ numberToCurrency(discountAmount) }}</dd>
              </div>
            </transition>
            <div v-if="model.purchase.include_repeat_discount" class="priceData-item paddingY2">
              <dt class="priceData-item-term">500円OFFリピート券2枚</dt>
              <dd class="priceData-item-desc">{{ numberToCurrency(500) }}</dd>
            </div>
            <div class="priceData-item paddingY2">
              <dt class="priceData-item-term">合計</dt>
              <dd class="priceData-item-desc">
                <template v-if="!ticket.original_stage_ticket_id && !isSelectedGroupDiscount">
                  {{ numberToCurrency(ticketTotalPrice) }}
                </template>
                <template v-else>
                  <span class="price">{{ numberToCurrency(ticketTotalPriceWithGroupDiscount) }}</span>
                  <span class="originPrice">{{ numberToCurrency(totalOriginStageTicketPrice) }}</span>
                </template>
              </dd>
            </div>
          </dl>
        </div>
      </div>
      <CouponForm v-if="displayCouponFeature" v-model:couponCode="model.purchase.coupon_code" @apply-coupon="applyCouponCode" />
      <CustomQuestion
        v-if="event.custom_question1 || event.custom_question2"
        v-model:first-answer="model.custom_question_answer1"
        v-model:second-answer="model.custom_question_answer2"
        :first-question="event.custom_question1"
        :second-question="event.custom_question2"
      />

      <!-- 回数券オプション（対象ユーザーのみ表示） -->
      <RepeatDiscountOption v-model="model.purchase.include_repeat_discount" :should-show="shouldShowRepeatDiscountOption" />

      <h2 class="textBold textLarge marginY2 marginT3">決済方法</h2>
      <div class="purchaseCard marginB4">
        <div v-if="isFreeTicket" class="paymentType">
          <input id="free" v-model="model.purchase.payment_method" class="paymentType-input" value="free" type="radio" />
          <label class="paymentType-label" for="free"
            ><span class="paymentType-label-radio" />
            {{ $useI18('purchase.enum.payment_method.free') }}
          </label>
        </div>
        <template v-else>
          <div class="paymentType">
            <input id="card" v-model="model.purchase.payment_method" class="paymentType-input" value="stripe_cc" type="radio" />
            <label class="paymentType-label" for="card"><span class="paymentType-label-radio" />クレジットカード</label>
            <stripe-credit-card-form v-show="isUsingCredit" ref="stripeCreditCardRef" />
          </div>
          <div class="paymentType">
            <input id="sbpayment_paypay" v-model="model.purchase.payment_method" class="paymentType-input" value="sbpayment_paypay" type="radio" />
            <label class="paymentType-label" for="sbpayment_paypay"><span class="paymentType-label-radio" />PayPay</label>
          </div>
          <template v-if="!isFiveMinutesEvent">
            <div v-if="ticket.payment_cvs_selectable" class="paymentType">
              <input id="convenience" v-model="model.purchase.payment_method" class="paymentType-input" value="stripe_cvs" type="radio" />
              <label class="paymentType-label" for="convenience"><span class="paymentType-label-radio" />コンビニ（+330円システム手数料）</label>
            </div>
            <div class="paymentType">
              <input id="docomo" v-model="model.purchase.payment_method" class="paymentType-input" value="ntt_docomo" type="radio" />
              <label class="paymentType-label" for="docomo"><span class="paymentType-label-radio" />d払い</label>
            </div>
            <div class="paymentType">
              <input id="sbpayment_au" v-model="model.purchase.payment_method" class="paymentType-input" value="sbpayment_au" type="radio" />
              <label class="paymentType-label" for="sbpayment_au"><span class="paymentType-label-radio" />au PAY（auかんたん決済）</label>
            </div>
            <div class="paymentType">
              <input
                id="sbpayment_softbank"
                v-model="model.purchase.payment_method"
                class="paymentType-input"
                value="sbpayment_softbank"
                type="radio"
              />
              <label class="paymentType-label" for="sbpayment_softbank"><span class="paymentType-label-radio" />ソフトバンクまとめて支払い</label>
            </div>
            <div v-if="isChocomEmoneyAvailable" class="paymentType">
              <input id="emoney" v-model="model.purchase.payment_method" class="paymentType-input" value="ntt_emoney" type="radio" />
              <label class="paymentType-label" for="emoney"><span class="paymentType-label-radio" />ちょコムeマネー</label>
            </div>
            <div v-if="!ticket.payment_cvs_selectable" class="purchaseCard-subtext margin2 paddingX3">
              ※締切日の2日前を過ぎた為、コンビニ支払は選択できません。
            </div>
          </template>
        </template>
      </div>
      <TotalPrice
        :event="event"
        :model-quantity="model.quantity"
        :final-actual-price="finalActualPrice"
        :can-go-to-next-page="canGoToNextPage"
        :agree-provide-info="agreeProvideInfo"
        :is-terms-agreed="isTermsAgreed"
        :is-marriage-member-event="isMarriageMemberEvent"
        :is-guest-purchase="true"
        :processing="processing"
        :privacy-policy-description="privacyPolicyDescription"
        @update-agree-provide-info="onUpdateAgreeProvideInfo"
        @update-terms-agreed="onUpdateTermsAgreed"
        @to-next-page="toPurchaseConfirm"
      />
      <div class="backlink marginT5" @click="toPurchaseOption($route.query.quantity || 1)">戻る</div>
    </div>
    <purchase-confirmation
      v-else-if="confirm"
      :model="model.purchase"
      :ticket="ticket"
      :event="event"
      :stripe-payment-token="stripePaymentToken"
      :is-guest-purchase="true"
      @go-back="backToPurchasePage"
      @confirm-purchase="handleConfirmPurchase"
    />
    <otp-phone-number-confirmation
      v-else
      :phone-number="model.profile.phone_number"
      :processing="processing"
      :stripe-payment-token-id="stripePaymentToken.id"
      :using-credit="isUsingCredit"
      :is-login-step="isLoginStep"
      :purchase-model="model"
      @go-back="closeOtpConfirmation"
      @retouch-phone-number="focusPhoneNumberInput"
      @retry-request="retryOtpRequest"
    />

    <!-- 回数券モーダル -->
    <div>
      <repeat-discount-modal
        :should-show-modal="shouldShowRepeatDiscountModal"
        @close-modal="closeRepeatDiscountModal"
        @purchase-with-repeat-discount="handlePurchaseWithRepeatDiscount"
        @purchase-without-repeat-discount="handlePurchaseWithoutRepeatDiscount"
      />
    </div>
  </div>
</template>

<script>
import { numberToCurrency, timeConverter } from '@/utils/converter'
import { flattenArray } from '@/utils/array'
import { scrollToTop } from '@/utils/ScrollTo'
import ChocomEmoneyMixin from '@/utils/mixins/ChocomEmoneyMixin'
import OnlineEventMixin from '@/utils/mixins/OnlineEventMixin'
import PurchaseMixin from '@/utils/mixins/PurchaseMixin'
import BrowserBackMixin from '@/utils/mixins/BrowserBackMixin'
import GTM from '@/utils/tracking/gtm'
import { pushAdAddToCart } from '@/utils/tracking/adCheckoutEvents'
import CriteoGtmDatalayer from '@/utils/CriteoGtmDatalayer'
import { LINKBAL_ID_IDP_URL, LINKBAL_ID_CLIENT_ID } from '@/utils/settings'
import { useMainStore } from '@/store'
import { reactive } from 'vue'
import useABTestV2 from '@/utils/abtest/useABTestV2'
import { REPEAT_DISCOUNT_AB_TEST_CONFIG } from '@/utils/abtest/abTestConfig'
import { sendRepeatDiscountViewEvent } from '@/utils/abtest/repeatDiscountGAEvent'
import Cookies from 'mj-cookie'
import { isSoloParticipationEvent } from '@/utils/purchaseValidation'

const FlashMessage = defineAsyncComponent(() => import('@/components/FlashMessage.vue'))
const CommonFlashMessage = defineAsyncComponent(() => import('@/components/CommonFlashMessage.vue'))
const CouponForm = defineAsyncComponent(() => import('@/components/purchase/CouponForm.vue'))
const OtpPhoneNumberConfirmation = defineAsyncComponent(() => import('@/components/purchase/OtpPhoneNumberConfirmation.vue'))
const StripeCreditCardForm = defineAsyncComponent(() => import('@/components/purchase/StripeCreditCardForm.vue'))
const UserProfileForm = defineAsyncComponent(() => import('@/components/purchase/UserProfileForm.vue'))
const PaymentStatusNotificationMessage = defineAsyncComponent(() => import('@/components/purchase/PaymentStatusNotificationMessage.vue'))
const CommonStepBar = defineAsyncComponent(() => import('@/components/CommonStepBar.vue'))
const CustomQuestion = defineAsyncComponent(() => import('@/components/purchase/CustomQuestion.vue'))
const TotalPrice = defineAsyncComponent(() => import('@/components/purchase/TotalPrice.vue'))
const RepeatDiscountModal = defineAsyncComponent(() => import('@/components/modals/RepeatDiscountModal.vue'))
const RepeatDiscountOption = defineAsyncComponent(() => import('@/components/purchase/RepeatDiscountOption.vue'))
const PurchaseConfirmation = defineAsyncComponent(() => import('@/components/purchase/PurchaseConfirmation.vue'))

const CVS_COMMISSION = 330
const MONTHS_IN_YEAR = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
const DEFAULT_PURCHASE = {
  quantity: null,
  payment_method: null,
  custom_question_answer1: null,
  custom_question_answer2: null,
  include_repeat_discount: false,
  coupon_code: null,
  verified_coupon_code: null
}
export default {
  components: {
    FlashMessage,
    OtpPhoneNumberConfirmation,
    StripeCreditCardForm,
    UserProfileForm,
    CommonStepBar,
    CommonFlashMessage,
    PaymentStatusNotificationMessage,
    CouponForm,
    CustomQuestion,
    TotalPrice,
    RepeatDiscountModal,
    RepeatDiscountOption,
    PurchaseConfirmation
  },
  mixins: [OnlineEventMixin, PurchaseMixin, BrowserBackMixin, ChocomEmoneyMixin],
  async setup() {
    const store = useMainStore()
    const route = useRoute()
    const params = route.params
    const query = route.query
    const app = useNuxtApp()
    definePageMeta({
      middleware: [
        function (to) {
          const store = useMainStore()
          const isSpecialPass =
            to.params.code === import.meta.env.KONKATSU_FREEPASS_EVENT_CODE || to.params.code === import.meta.env.MENSPASS_EVENT_CODE
          // TODO: Add (params.code !== 'aCYmCg') to following condition for test on production
          if (store.$state.auth_info || isSpecialPass) {
            navigateTo(`/events/${to.params.code}/tickets/${to.params.ticket_id}/purchases/new/?quantity=${to.query.quantity || 1}`)
          }
        }
      ],
      layout: 'simple'
    })
    const payload = { eventCode: params.code, ticketId: params.ticket_id, quantity: query.quantity }
    if (query['purchase[quantity]']) payload.quantity = query['purchase[quantity]']
    const purchaseRequest = store.dispatch('guestPurchaseNew', payload).then(response => {
      const profile = response.data.profile || {}
      profile.prefecture_id = response.data.event.prefecture_id
      if (response.data.ticket.gender !== 'both_gender') profile.gender = response.data.ticket.gender

      return {
        errorMessages: response.data.error_messages || [],
        ticket: response.data.ticket,
        event: response.data.event,
        soloParticipationOnly: isSoloParticipationEvent(response.data.event.event_title),
        model: {
          purchase: response.data.purchase || DEFAULT_PURCHASE,
          profile
        }
      }
    })
    const paymentStatusNotificationRequest = store.dispatch('apiGet', 'payment_status_notifications').then(res => {
      return {
        payment_status_notification: res.data.payment_status_notification
      }
    })
    const criteoGtmDatalayer = new CriteoGtmDatalayer(store)
    const requests = [purchaseRequest, paymentStatusNotificationRequest, criteoGtmDatalayer.fetchData()]

    const { sendOnPaymentPageClick } = usePaymentFlowABTest()

    try {
      const [mainContents, paymentStatusNotificationContents, gtmContents] = await Promise.all(requests)
      return reactive({ ...mainContents, ...paymentStatusNotificationContents, ...gtmContents, sendOnPaymentPageClick })
    } catch (e) {
      const errorCode = parseInt(e.response && e.response.status)
      await app.$error(errorCode)
    }
  },
  data: function () {
    // A/Bテストの実行
    const repeatDiscountABTest = useABTestV2(REPEAT_DISCOUNT_AB_TEST_CONFIG)

    return {
      displayTooltip: false,
      displayOtpConfirm: false,
      processing: false,
      isTermsAgreed: false,
      isLoginStep: false,
      agreeProvideInfo: false,
      stripePaymentToken: {},
      // A/Bテスト結果
      repeatDiscountABTest,
      // 回数券モーダル関連
      includeRepeatDiscount: false,
      // 確認画面状態
      confirm: false
    }
  },
  computed: {
    duplicatedEmailMsg() {
      const signInUrl = `${LINKBAL_ID_IDP_URL}/v2/login?client_id=${LINKBAL_ID_CLIENT_ID}`
      return `このメールアドレスは既に登録されています。<a href="${signInUrl}">こちら</a>からログインにお進みください。`
    },
    ticketName() {
      if (this.isSpecialPass) return this.event.event_title.replace(/(婚活フリーパス|メンズパス)/, '')
      return `${this.ticket.name}チケット`
    },
    groupDiscountAmount() {
      if (!this.ticket.group_discounts || this.model.purchase.quantity === 1) return 0
      const genderGroupDiscounts = this.ticket.group_discounts.filter(d => d.gender === this.model.profile.gender)
      const discountData = genderGroupDiscounts.find(d => d.applicable_person_count === this.model.purchase.quantity)
      return discountData.discount_price
    },
    monthsInYear() {
      return MONTHS_IN_YEAR
    },
    ticketTotalPrice() {
      let totalPrice = this.purchasePrice * this.model.purchase.quantity - (this.discountAmount || 0)
      // 回数券が選択されている場合は500円を追加
      if (this.model.purchase.include_repeat_discount) {
        totalPrice += 500
      }
      return totalPrice > 0 ? totalPrice : 0
    },
    commissionFee() {
      return this.model.purchase.payment_method === 'stripe_cvs' ? CVS_COMMISSION : 0
    },
    ticketTotalPriceWithGroupDiscount() {
      return this.ticketTotalPrice - this.groupDiscountAmount
    },
    totalOriginStageTicketPrice() {
      const ticketPrice = this.ticket.original_stage_ticket_price || this.ticket.price
      return ticketPrice * this.model.purchase.quantity
    },
    finalActualPrice() {
      return this.ticketTotalPriceWithGroupDiscount + this.commissionFee
    },
    eventOrganizationTime() {
      if (this.event.event_type === 'bar_gourmet') {
        const startAt = timeConverter(this.event.start_at).fullDate
        const endAt = timeConverter(this.event.end_at).fullDate
        return startAt === endAt ? `${startAt}〜` : `${startAt}〜${endAt}`
      }
      const startDate = timeConverter(this.event.start_at).fullDateWithoutYear
      return `${startDate} `
    },
    eventStartToday() {
      if (this.event.event_type === 'bar_gourmet') return false
      const today = timeConverter().dateTime
      return today.isBetween(this.event.start_at, this.event.end_at, 'day', '[]')
    },
    isFreeTicket() {
      return Number(this.ticketTotalPrice) === 0 && Number(this.model.purchase.quantity) !== 0
    },
    quantitySelectOptions() {
      const maxQuantity = this.ticket.selectable_quantity_max
      const list = []

      if (this.soloParticipationOnly) {
        list.push({
          value: 1,
          text: `1枚 ${1 > this.ticket.available_quantity ? '✖' : '〇'}`,
          disabled: 1 > this.ticket.available_quantity
        })
        return list
      }

      for (let i = 1; i <= maxQuantity; i++) {
        const unavailableText = this.ticket.original_stage_ticket_id ? '△ 通常チケット価格在庫あり' : '✖'
        list.push({
          value: i,
          text: `${i}枚 ${i > this.ticket.available_quantity ? `${unavailableText}` : '〇'}`,
          disabled: i > this.ticket.available_quantity
        })
      }
      return list
    },
    canSelectQuantity() {
      if (this.soloParticipationOnly) return false
      return (
        !this.isOnlineEvent &&
        !this.isOnlineServiceLinktextEvent &&
        (this.ticket.quantity_changeable || this.ticket.original_stage_ticket_id) &&
        !this.isSpecialPass &&
        (!this.isMarriageMemberEvent || this.isMdgMemberPartyEvent)
      )
    },
    canGoToNextPage() {
      if (this.isMarriageMemberEvent || this.event.provide_user_info_event || this.event.change_organizer_privacy_policy)
        return this.model.purchase.payment_method && this.isTermsAgreed && this.agreeProvideInfo
      return this.model.purchase.payment_method && this.isTermsAgreed
    },
    needDisplayTooltip() {
      if (this.soloParticipationOnly) return true
      return (!this.ticket.quantity_changeable && !this.ticket.original_stage_ticket_id) || this.model.purchase.quantity > 1
    },
    tooltipText() {
      if (this.soloParticipationOnly) return '一人参加限定イベントのため、1枚のみ購入可能です'
      if (!this.ticket.quantity_changeable && !this.ticket.original_stage_ticket_id) return 'チケット残数が1枚のため複数購入することができません'
      if (this.model.purchase.quantity > 1) return 'まとめてご購入いただいたうち、一部のチケットのキャンセルはできません'
      return ''
    },
    isUsingCredit() {
      return this.model.purchase.payment_method === 'stripe_cc'
    },

    // 回数券オプションを表示するかどうか（ゲストの場合はA/Bテストのみで判定）
    shouldShowRepeatDiscountOption() {
      return this.repeatDiscountABTest.isBPattern
    },

    // 回数券モーダルを表示するかどうか
    shouldShowRepeatDiscountModal() {
      return this.repeatDiscountABTest.isBPattern
    },
    ageConditions() {
      return {
        male_age_upper: this.event.male_age_upper,
        male_age_lower: this.event.male_age_lower,
        female_age_upper: this.event.female_age_upper,
        female_age_lower: this.event.female_age_lower,
        event_start_date: this.event.start_at
      }
    },
    isSpecialPass() {
      return this.event.code === import.meta.env.KONKATSU_FREEPASS_EVENT_CODE || this.event.code === import.meta.env.MENSPASS_EVENT_CODE
    },
    guestUserDataForGTM() {
      const now = timeConverter().fullJoinedDate
      const birthday = timeConverter(this.model.profile.birthdate).fullJoinedDate
      // if this.profile.birthdate is undefinded, age will be 0
      const age = Math.floor((now - birthday) / 10000)

      return {
        profile_birthdate: this.model.profile.birthdate || '',
        profile_age: age || null,
        profile_gender: this.model.profile.gender || '',
        profile_prefecture: this.event.prefecture_name || ''
      }
    },
    lbiError() {
      const lbiStatusCode = this.$route.query.lbi_status_code
      return lbiStatusCode ? `lbi_error_${lbiStatusCode}` : null
    },
    isMarriageMemberEvent() {
      return this.event.marriage_member_event
    },
    isMdgMemberPartyEvent() {
      return this.event.mdg_member_party_event
    },
    hasGroupDiscount() {
      return this.ticket.group_discounts
    },
    isSelectedGroupDiscount() {
      return this.hasGroupDiscount && this.model.purchase.quantity > 1
    },
    privacyPolicyDescription() {
      if (this.event.change_organizer_privacy_policy) return 'プロモーションに関するご案内'
      return '婚活に関するご案内や結婚相談所の紹介等'
    },
    displayCouponFeature() {
      return this.ticket.can_use_coupon_feature
    },
    discountAmount() {
      if (!this.ticket.coupon_discount_price || this.ticket.coupon_discount_price <= 0) return null
      return this.ticket.coupon_discount_price
    }
  },
  watch: {
    isFreeTicket(to) {
      if (to) {
        this.model.purchase.payment_method = 'free'
      } else this.model.purchase.payment_method = 'stripe_cc'
    }
  },
  created() {
    this.initModel()
  },
  mounted() {
    this.showAndHideTooltip()
    this.pushGtmData()
    // mj-issues#789: 広告ピクセルの AddToCart 用(割引前の チケット単価 × 枚数)
    pushAdAddToCart({ event: this.event, unitPrice: this.purchasePrice, quantity: this.model.purchase.quantity })

    // Send AB test payment page GA event
    this.sendOnPaymentPageClick()

    // 回数券を購入可能の場合（ゲストユーザーもA/Bテスト対象）
    sendRepeatDiscountViewEvent(this.$store, REPEAT_DISCOUNT_AB_TEST_CONFIG)
  },
  methods: {
    numberToCurrency,
    initModel() {
      this.model.purchase.quantity = this.ticket.quantity || this.$route.query.quantity || 1
      this.model.purchase.payment_method = this.isFreeTicket ? 'free' : 'stripe_cc'
    },
    onChangeQuantity() {
      if (this.model.purchase.quantity > this.ticket.available_quantity && this.ticket.original_stage_ticket_id) {
        const payload = { ticket: this.ticket }
        this.$store.MODAL({ name: 'StageTicketWarningModal', payload })
        this.model.purchase.quantity =
          this.ticket.available_quantity > this.ticket.selectable_quantity_max ? this.ticket.selectable_quantity_max : this.ticket.available_quantity
        this.fetchNewTicket()
      } else {
        this.fetchNewTicket()
        this.$router.push({ path: this.$route.path, query: { quantity: this.model.purchase.quantity } })
        if (this.model.purchase.quantity > 1) this.showAndHideTooltip()
      }
    },
    setErrorMessages(messages) {
      // エラー時は確認画面から戻り、同意状態をリセット
      if (this.confirm) {
        this.confirm = false
        this.isTermsAgreed = false
        this.agreeProvideInfo = false
      }
      if (messages instanceof Array) {
        this.errorMessages = messages
      } else {
        this.errorMessages = [messages]
      }
      scrollToTop()
    },
    fetchNewTicket() {
      this.errorMessages = []
      const payload = {
        eventCode: this.$route.params.code,
        ticketId: this.$route.params.ticket_id,
        quantity: this.model.purchase.quantity
      }
      if (this.model.purchase.coupon_code) {
        payload.applyCoupon = true
        payload.couponCode = this.model.purchase.coupon_code
        payload.firstVisitGuestCouponSessionId = Cookies.get('first_visit_guest_coupon_session_id')
      }
      return this.$store
        .dispatch('guestPurchaseNew', payload)
        .then(res => {
          this.ticket = res.data.ticket
          if (payload.applyCoupon) {
            if (res.data.error_messages) {
              this.model.purchase.verified_coupon_code = null
              this.setErrorMessages(`クーポンが適用されませんでした。${res.data.error_messages}`)
            } else {
              this.model.purchase.verified_coupon_code = payload.couponCode
              if (this.$refs.priceDataElement) {
                scrollTo(this.$refs.priceDataElement)
              }
            }
          } else if (res.data.error_messages) {
            this.setErrorMessages(res.data.error_messages)
          }
        })
        .catch(() => {
          this.setErrorMessages('システムエラーが発生しました。もう一度やってみてください！')
        })
    },
    // 確認画面に遷移する
    async toPurchaseConfirm() {
      if (!this.canGoToNextPage) return
      if (!this.validateData()) return this.finishProcessing()

      this.model.profile = this.$refs.userProfileForm.profile
      if (this.isUsingCredit) {
        this.startProcessing()
        if (!(await this.confirmPaymentMethod())) return this.finishProcessing()
        this.finishProcessing()
      }

      this.confirm = true
    },

    async toOtpConfirm() {
      this.startProcessing()
      await this.postPurchaseData()
      this.pushGtmData()
      this.finishProcessing()
    },
    finishProcessing() {
      this.processing = false
    },
    startProcessing() {
      this.errorMessages = []
      this.processing = true
    },
    validateData() {
      const validateMessages = this.$refs.userProfileForm.validateUserProfile() || []
      const errorMessages = flattenArray(validateMessages)
      if (errorMessages.length > 0) return this.setErrorMessages(errorMessages)
      return true
    },
    postPurchaseData() {
      this.processing = true
      const payload = {
        eventCode: this.$route.params.code,
        ticketId: this.$route.params.ticket_id,
        postData: this.model
      }
      if (this.model.purchase.coupon_code) payload.postData.first_visit_guest_coupon_session_id = Cookies.get('first_visit_guest_coupon_session_id')
      return this.$store
        .dispatch('postGuestValidate', payload)
        .then(res => {
          if (res.data.error === 'email_duplicated') {
            this.isLoginStep = false
            return this.setErrorMessages(this.duplicatedEmailMsg)
          } else if (res.data.error === 'phone_number_duplicated') {
            this.isLoginStep = true
          } else if (res.data.error) {
            return this.setErrorMessages(this.$useI18('errors.guest_validate')[res.data.error] || this.$useI18('errors.default'))
          }
          this.displayOtpConfirm = true
        })
        .catch(() => {
          this.setErrorMessages(this.$useI18('errors.default'))
        })
    },
    async confirmPaymentMethod() {
      const stripeCreditCardRef = this.$refs.stripeCreditCardRef
      const { error, confirmationToken } = await stripeCreditCardRef.createPaymentToken()

      if (error) {
        this.setErrorMessages(this.$useI18('errors.default'))
        return false
      } else {
        this.stripePaymentToken = confirmationToken
        return true
      }
    },
    showAndHideTooltip() {
      this.displayTooltip = true
      setTimeout(() => {
        this.displayTooltip = false
      }, 5000)
    },
    pushGtmData() {
      const gtm = new GTM(this.$route, this.$store)
      GTM.pushData({ ...gtm.defaultData, ...this.guestUserDataForGTM })
      const productList = [{ id: `${this.event.id}`, price: `${this.purchasePrice}`, quantity: `${this.model.purchase.quantity}` }]
      GTM.pushData({
        PageType: 'Basketpage',
        HashedEmail: this.gtmDatalayer.hashed_email,
        ProductBasketProducts: productList,
        Ui_userlv: this.gtmDatalayer.ui_userlv
      })
      GTM.trackingPageView(this.$route)
    },
    async retryOtpRequest() {
      this.startProcessing()
      await this.postPurchaseData()
      if (this.errorMessages.length > 0) this.closeOtpConfirmation()
      this.finishProcessing()
    },
    focusPhoneNumberInput() {
      this.closeOtpConfirmation()
      this.$nextTick(() => {
        this.$refs.userProfileForm.focusPhoneNumberInput()
      })
    },
    closeOtpConfirmation() {
      this.displayOtpConfirm = false
      this.isTermsAgreed = false
      this.agreeProvideInfo = false
    },
    onUpdateTermsAgreed(value) {
      this.isTermsAgreed = value
    },
    onUpdateAgreeProvideInfo(value) {
      this.agreeProvideInfo = value
    },

    // 回数券モーダル関連のメソッド
    closeRepeatDiscountModal() {
      // モーダルを閉じた場合は回数券なし（チェックボックスOFF）
      this.includeRepeatDiscount = false
      this.model.purchase.include_repeat_discount = false
    },

    handlePurchaseWithRepeatDiscount() {
      this.includeRepeatDiscount = true
      this.model.purchase.include_repeat_discount = true
      // モーダルで「追加する」を選択した場合、チェックボックスが自動的にONになる
    },

    handlePurchaseWithoutRepeatDiscount() {
      this.includeRepeatDiscount = false
      this.model.purchase.include_repeat_discount = false
      // モーダルで「追加しない」を選択した場合、チェックボックスが自動的にOFFになる
    },
    applyCouponCode(e) {
      e.preventDefault()
      if (!this.model.purchase.coupon_code) {
        this.setErrorMessages('クーポンが適用されませんでした。クーポンコードが入力されていません')
      } else {
        this.fetchNewTicket()
      }
    },

    // 確認画面から戻る
    backToPurchasePage() {
      this.confirm = false
      this.isTermsAgreed = false
      this.agreeProvideInfo = false
      scrollToTop()
    },

    // 確認画面からの購入確定処理
    async handleConfirmPurchase() {
      if (this.processing) return
      await this.toOtpConfirm()
      this.confirm = false
    }
  }
}
</script>

<style lang="scss" scoped>
.commonWrap {
  padding: 0 1.5rem;
}

.priceData {
  &-item {
    @include flex;
    position: relative;
    justify-content: space-between;
    border-bottom: 1px solid $gray-c6;
    font-size: 1.2rem;
    color: $gray-55;
    &-desc {
      text-align: right;
      select {
        color: $black-1a;
        max-width: 100px;
        height: 32px;
        font-size: 1.4rem;
      }
      .price {
        font-size: 1.6rem;
        color: $pink-thin;
        font-weight: 900;
      }
      .originPrice {
        padding-right: 5px;
        text-decoration: line-through;
      }
    }
    &-tooltip {
      position: absolute;
      width: 85%;
      bottom: 50px;
      right: 0;
      padding: 0.8rem 1rem 0.6rem;
      border-radius: 3px;
      background-color: $gray-55;
      color: $white;
      box-shadow: 0 3px 6px 0 rgba($black, 0.3);
      z-index: 1;
      font-size: 1.4rem;
      @media screen and (min-width: 960px) {
        width: 35%;
      }
      &::before,
      &::after {
        display: block;
        position: absolute;
        background-color: $gray-55;
        content: '';
      }
      &::before {
        right: 50px;
        bottom: -8px;
        width: 24px;
        height: 24px;
        transform: rotate(45deg);
        border-radius: 3px;
        box-shadow: 0 3px 6px 0 rgba($black, 0.3);
        z-index: 2;
      }
      &::after {
        right: 42px;
        bottom: 0;
        width: 40px;
        height: 20px;
        z-index: 3;
      }
      &-inner {
        position: relative;
        z-index: 10;
      }
    }
    &-group-discount {
      width: fit-content;
      padding: 2px;
      border-radius: 2px;
      background: $pink-thin;
      font-size: 1rem;
      font-weight: 700;
      text-align: right;
      color: $white;
    }
  }
}

.paymentType {
  &:not(:last-child) {
    border-bottom: 1px solid $gray-c6;
  }
  position: relative;
  &-label {
    font-weight: bold;
    color: $gray-80;
    @include flex;
    justify-content: flex-start;
    padding: 1rem;
    margin: 0.8rem 0;
    transition: 0.2s;
    &-radio {
      width: 11px;
      height: 11px;
      margin: auto 1.2rem auto 0.6rem;
      background: $white;
      box-shadow: 0 0 0 4px $black-01;
      border-radius: 10px;
      transition: 0.2s;
    }
    &-logo {
      position: absolute;
      right: 15px;
      width: 7rem;
      @media screen and (min-width: 360px) {
        width: 13rem;
      }
    }
  }
  &-input {
    display: none;
    &:checked + .paymentType-label {
      color: $black-1a;
      .paymentType-label-radio {
        background: $positive-green-light;
        box-shadow: 0 0 0 4px $positive-green-dark;
      }
    }
  }
}

.backlink {
  font-size: 1.2rem;
  text-decoration: none;
  color: $gray-55;
  border: none;
  background: none;
  cursor: pointer;
}

.purchaseCard {
  border: 1px solid $gray-c6;
  border-radius: 3px;
  &-event {
    font-size: 1.2rem;
    &-box {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      font-size: 1.6rem;
      font-weight: bold;
      &-eyecatch {
        max-height: 50px;
        display: inline-block;
      }
      &-block {
        display: inline-block;
        padding-left: 10px;
        &-today {
          display: inline-block;
          padding: 2px 5px 0;
          border: 1px solid $pink-thin;
          color: $pink-thin;
          font-size: 1rem;
        }
        &-area {
          font-size: 1rem;
        }
      }
    }
    &-title {
      font-weight: bold;
      color: $gray-55;
    }
  }
  &-totalPrice {
    font-size: 2.4rem;
    font-weight: bold;
    text-align: center;
  }
  &-numOfTicket {
    font-size: 1.4rem;
    font-weight: bold;
    text-align: center;
  }
  &-confirmText {
    font-size: 1rem;
    color: $gray-55;
    &-contentBox {
      display: flex;
      .btn-checkbox {
        margin-right: 2rem;
      }
    }
  }
  &-priceData {
    font-size: 1.2rem;
    border-top: 1px solid $gray-c6;
    font-weight: bold;
  }
  &-subtext {
    color: $gray-55;
    font-size: 1rem;
  }
}
</style>
